import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../shared/services/authentication.service';

@Component({
  selector: 'app-pda-receiving',
  templateUrl: './pda-receiving.component.html',
  styleUrls: ['./pda-receiving.component.scss']
})
export class PdaReceivingComponent implements OnInit {

  constructor(
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/pda/receiving/pda-receiving.component.ts